module.exports = __webpack_public_path__ + "static/media/sala_principal_1.375a4414.jpg";